import "./brand.css";

import {
  faCheck,
  faChevronRight,
  faHeart,
  faShare,
  faTimes,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Searsh from '../Searsh/Searsh'
import { useRef } from "react";
import {
  searsh_brand,
  show_brand,
  product_reviews,
  unfollow,
  sort_products,
  influencers_follow,
  filter_data,
  sort_data,
  filter_brducts,
  category_data,
  myProfile,
  product_details,
  remove_favorites,
  addFavorite,
  favorites,
  show_Influencer,
   show_store
} from "../Redux/API";
import { searsh_product } from "../Redux/HomeSlice";
import Loader from "../Loader";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TelegramShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  PinterestIcon,
  TelegramIcon,
} from "react-share";
import Register from "../Register/Register";
import { showRegister } from "../Redux/HomeSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css"; // استيراد التنسيقات الافتراضية

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
function Brand() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const gotoCategory = (category) => {
    if (category?.id) { // التحقق من وجود parent_id داخل الكائن
    dispatch(filter_data({influencer_id: null, brand_id: null, store_id: null, category_id: category.id}));
    dispatch(sort_data({influencer_id: null, brand_id: null, store_id: null, category_id: category.id}));
    localStorage.setItem("categoryData", JSON.stringify(category));
    dispatch(category_data(category));
    navigate("/SubSupCategory");
    window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    const id = localStorage.getItem("brandId");
    dispatch(show_brand({ id }));
  }, [dispatch]);

  // **حالة البحث**
  const [searshBroduct, setSearshBroduct] = useState("");
  const handleInputChangeReturns = (e) => {
    setSearshBroduct(e.target.value);
  };

  const [activeSource, setActiveSource] = useState(null); // حالة لتحديد المصدر النشط

  useEffect(() => {
    if (searshBroduct) {
      // استدعاء البحث
      dispatch(searsh_brand(
        {
          search: searshBroduct,
          influencer_id: null, 
          brand_id: id, 
          store_id: null, 
          category_id: null
        }
      ));
      dispatch({ type: "RESET_SHOW_BRAND" });
      dispatch({ type: "RESET_FILTER_PRODUCTS" });
      dispatch({ type: "RESET_SORT_PRODUCTS" });
      // تعيين المصدر النشط ليكون البحث
      setActiveSource("search");
    } else {
      // عرض العلامات التجارية
      dispatch(show_brand());
      // إعادة تعيين جميع البيانات الأخرى
      dispatch({ type: "RESET_FILTER_PRODUCTS" });
      dispatch({ type: "RESET_SORT_PRODUCTS" });
      dispatch({ type: "RESET_SEARCH_BRANDS" });
      // تعيين المصدر النشط ليكون العلامات التجارية
      setActiveSource("brands");
    }
  }, [searshBroduct, dispatch]);

  const gotoProductDetails = (product) => {
    localStorage.setItem("Product_id", product.id);
    dispatch(product_details(product.id));
    dispatch(product_reviews(product.id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));


    const id = product?.type?.id;
    if (!id || !product?.vendor_type) return;

    switch (product.vendor_type) {
      case "brand":
          localStorage.setItem('brandId', id);
          dispatch(show_brand({ id }));
          break;
      case "influencer":
          localStorage.setItem('InfluencerId', id);
          dispatch(show_Influencer({ id }));
          break;
      case "store":
          localStorage.setItem('storeId', id);
          dispatch(show_store({ id }));
          break;
      default:
          console.error("Unknown vendor type:", product.vendor_type);
    }
  };

  const loadingSort_products = useSelector(
    (state) => state.Data.loadingSort_products
  );
  const loadingSearsh_brand = useSelector(
    (state) => state.Data.loadingSearsh_brand
  );

  const loadingShow_brand = useSelector(
    (state) => state.Data.loadingShow_brand
  );

  const searsh_brands = useSelector((state) => state.Data.searsh_brand);
  const show_brands = useSelector((state) => state.Data.show_brand);
  const filter_brduct = useSelector((state) => state.Data.filter_brducts);
  const sort_product = useSelector((state) => state.Data.sort_products);

  const filters_data = useSelector((state) => state.Data.filter_data);
  const sorts_data = useSelector((state) => state.Data.sort_data);
  const loadingFilter_brduct = useSelector(
    (state) => state.Data.loadingFilter_brducts
  );

  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    let updatedProducts = [];

    // عرض منتجات العلامات التجارية فقط إذا كان المصدر هو "brands"
    if (activeSource === "brands" && show_brands?.data?.data?.brand?.products) {
      updatedProducts = [...show_brands?.data?.data?.brand?.products];
    }

    // عرض المنتجات المفلترة فقط إذا كان المصدر هو "filter"
    if (activeSource === "filter" && filter_brduct?.data?.data?.products) {
      updatedProducts = [...filter_brduct?.data?.data?.products];
    }

    // عرض نتائج البحث فقط إذا كان المصدر هو "search"
    if (activeSource === "search" && searsh_brands?.data?.data) {
      updatedProducts = [...searsh_brands?.data?.data];
    }

    // عرض المنتجات المرتبة فقط إذا كان المصدر هو "sort"
    if (activeSource === "sort" && sort_product?.data?.data?.products) {
      updatedProducts = [...sort_product?.data?.data?.products];
    }

    setAllProducts(updatedProducts);
  }, [activeSource, show_brands, filter_brduct, searsh_brands, sort_product]);

  const [icon, setIcon] = useState(false);
  const [text, setText] = useState(null);
  function handelClick() {
    setIcon(!icon);
  }

  function valueTeaxt(e) {
    setText(e);
  }

  useEffect(() => {
  const id = localStorage.getItem("brandId");
    dispatch(filter_data({influencer_id: null, brand_id: id, store_id: null}));
    dispatch(sort_data({influencer_id: null, brand_id: id, store_id: null}));
  }, [dispatch]);

  // دالة الفرز
  const id = localStorage.getItem("brandId");
  useEffect(() => {
    if (text) {
      // استدعاء الفرز
      dispatch(sort_products({
        sort: text,
        influencer_id: null,
        brand_id: id, 
        store_id: null, 
        category_id: null
      }));      // إعادة تعيين جميع البيانات الأخرى
      dispatch({ type: "RESET_SHOW_BRAND" });
      dispatch({ type: "RESET_FILTER_PRODUCTS" });
      dispatch({ type: "RESET_SEARCH_BRANDS" });
      setActiveSource("sort");
    }
  }, [dispatch, text]);

  const favorite = useSelector((state) => state?.Data?.favorites?.data?.data);
  const loadingRemove_favorites = useSelector(
    (state) => state.Data.loadingRemove_favorites
  );
  const loadingAddFavorite = useSelector(
    (state) => state.Data.loadingAddFavorite
  );
  console.log(favorite);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  const showR = useSelector((state) => state?.products?.showR);

  useEffect(() => {
    if (!loadingAddFavorite && !loadingRemove_favorites) {
      dispatch(favorites()); // قم بتحديث المفضلة بعد الإضافة أو الحذف
    }
  }, [dispatch, loadingAddFavorite, loadingRemove_favorites]);

  const handelAdd_wishlist = (id, event) => {
    if (token) {
      const isInWishlist = favorite?.some((item) => item.product_id === id);
      if (isInWishlist) {
        dispatch(remove_favorites(id));
      } else {
        dispatch(addFavorite({ id }));
      }
    } else {
      const { pageY } = event;
      const offsetY = -100; // إزاحة بسيطة لعرض الـ Popup تحت النقطة قليلاً
      setPopupPosition({ x: 50, y: pageY + offsetY }); // X في المنتصف باستخدام نسبة 50%، Y عند النقطة التي تم الضغط عليها
      dispatch(showRegister(true));
    }
  };

  const loadingUnfollow = useSelector((state) => state?.Data.loadingUnfollow);

  const following = useSelector(
    (state) =>
      state?.Data?.myProfile?.data?.data?.user?.following_influencers || []
  );

  useEffect(() => {
    if (!loadingUnfollow) {
      dispatch(myProfile());
    }
  }, [dispatch, loadingUnfollow]);

  // التحقق مما إذا كان الـ Influencer في قائمة المتابعة
  const isFollowing = following.some(
    (influencer) => influencer.id === show_brands?.data?.data?.brand?.id
  );

  // دالة المتابعة/إلغاء المتابعة بناءً على الحالة
  const handleFollowToggle = (id, event) => {
    if (token) {
      if (isFollowing) {
        // إذا كان المتابع موجود، ننفذ Unfollow
        dispatch(unfollow({ id }));
      } else {
        // إذا لم يكن المتابع موجود، ننفذ Follow
        dispatch(influencers_follow({ id }));
      }
    } else {
      // حساب الموقع إذا لم يكن المستخدم مسجل دخول
      const { pageY } = event;
      const offsetY = -100;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true)); // عرض نافذة التسجيل
    }
  };

  const [openIndex, setOpenIndex] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({
    brands: [],
    categories: [],
    prices: [],
    discounts: [],
    colors: [],
    sizes: [],
    influencer_id: null,
    brand_id: id, 
    store_id: null, 
    category_id: null

  });

  const handleFilterDataClick = () => {
    dispatch(filter_brducts(selectedFilters));
    dispatch({ type: "RESET_SHOW_BRAND" });
    dispatch({ type: "RESET_SORT_PRODUCTS" });
    dispatch({ type: "RESET_SEARCH_BRANDS" });
    setActiveSource("filter");
    if (window.innerWidth <= 576) {
      toggleFilterVisibility();
    }
  };

  const items = [
    {
      title: t("categories"),
      key: "categories",
      subItems: filters_data?.data?.data?.categories,
    },
    {
      title: t("prices"),
      key: "prices",
      subItems: filters_data?.data?.data?.prices,
    },
    {
      title: t("discounts"),
      key: "discounts",
      subItems: filters_data?.data?.data?.discounts,
    },
    {
      title: t("sizes"),
      key: "sizes",
      subItems: filters_data?.data?.data?.sizes,
    },
  ];

  const handleAddFilter = (type, filter) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };

      if (!Array.isArray(updatedFilters[type])) {
        updatedFilters[type] = [];
      }

      if (type === "brands") {
        if (updatedFilters[type].includes(filter.id)) {
          updatedFilters[type] = updatedFilters[type].filter(
            (id) => id !== filter.id
          );
        } else {
          updatedFilters[type] = [...updatedFilters[type], filter.id];
        }
      } else {
        if (updatedFilters[type].includes(filter.title)) {
          updatedFilters[type] = updatedFilters[type].filter(
            (title) => title !== filter.title
          );
        } else {
          updatedFilters[type] = [...updatedFilters[type], filter.title];
        }
      }

      return updatedFilters;
    });
  };
  const icons3 = [
    ["", "", "", ""],
    ["", "", ""],
    ["", ""],
  ];
  const [openInde, setOpenInde] = useState(2);
  const handleRs = (index) => {
    setOpenInde(index);
  };

  const [showShareButtons, setShowShareButtons] = useState(false);
  const [popupPosition2, setPopupPosition2] = useState({ x: 0, y: 0 });

  const toggleShareButtons = (event) => {
    setShowShareButtons((prev) => !prev);
    const { clientX, clientY } = event;
    setPopupPosition2({ x: clientX, y: clientY + 200 });
  };

  console.log(show_brands);
  const currentUrl = `${window.location.origin}/Brand?id=${show_brands?.data?.data?.brand?.id}`; // الرابط مع إضافة id
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        alert("تم نسخ رابط الصفحة إلى الحافظة!");
      })
      .catch((err) => {
        console.error("فشل في النسخ:", err);
      });
  };

  const location = useLocation();

  useEffect(() => {
    // استخراج `id` من الـ URL
    const params = new URLSearchParams(location.search);
    const brandId = params.get("id");

    if (brandId) {
      dispatch(show_brand({ id: brandId }));
      localStorage.setItem("influencerId", brandId); // تخزين `id` للاستخدامات الأخرى إذا لزم
    } else {
      console.log("No brand id found in URL");
    }
  }, [location.search, dispatch]);

  const Sign_Up = (event) => {
    if (!token) {
      const { pageY } = event;
      const offsetY = -1200;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true));
    }
  };

  const show_searsh = useSelector((state) => state?.products?.searsh);
  const searsh = useSelector((state) => state.Data.searsh_brand);

  const [isFilterVisible, setIsFilterVisible] = useState(true); // التحكم في ظهور الفلتر

  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const menuRef = useRef(null);
  const shareRef = useRef(null);

  const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIcon(false); 
      }
      if (shareRef.current && !shareRef.current.contains(event.target)) {
      setShowShareButtons(false);
    }
  };

  useEffect(() => {
      if (icon || showShareButtons) {
          document.addEventListener("mousedown", handleClickOutside);
      } else {
          document.removeEventListener("mousedown", handleClickOutside);
      }

      return () => {
          document.removeEventListener("mousedown", handleClickOutside);
      };
  }, [icon, showShareButtons]);

  return (
    <div className="Brand">
      <Header />
      {showR && (
        <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}

      {show_searsh && (
        <Searsh />
      )}
      <div className="containerBrand container">
        <div className="row justify-content-between align-items-end">
          {loadingShow_brand && <Loader />}
          <div className="col-12 col-sm-5 col-md-5 col-lg-3" ref={shareRef}>
          <div className="border_box">
              <img src={show_brands?.data?.data?.brand?.logo}/>
            </div>
            <div className="image mt-3">
              <div
                className="box_Share"
                onClick={(event) => (
                  copyToClipboard, toggleShareButtons(event)
                )}
              >
                <span className="Share">
                  <FontAwesomeIcon icon={faShare} />
                </span>
              </div>
            </div>
            {showShareButtons && (
              <div
                className="shareButtons mt-3 pt-2"
                style={{
                  position: "absolute",
                  left: popupPosition2.x,
                  top: popupPosition2.y,
                  transform: "translate(-50%, -50%)",
                  zIndex: 2,
                }}
                onClick={toggleShareButtons}
              >
                <FacebookShareButton url={currentUrl}>
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton url={currentUrl}>
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
                <WhatsappShareButton url={currentUrl}>
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>
                <LinkedinShareButton url={currentUrl}>
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>
                <PinterestShareButton url={currentUrl}>
                  <PinterestIcon size={32} round />
                </PinterestShareButton>
                <TelegramShareButton url={currentUrl}>
                  <TelegramIcon size={32} round />
                </TelegramShareButton>
              </div>
            )}
          </div>
          <div className="col-12 col-sm-5 col-md-5 col-lg-3 justify-content-around">
            <h2>{show_brands?.data?.data?.brand?.name}</h2>
            <div className="">
              <input
                type="text"
                value={searshBroduct}
                onChange={handleInputChangeReturns}
                placeholder={t("products search...")}
              />
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-4 mt-sm-2 p-1">
            <ul
              style={{
                margin: 0,
                padding: "20px 30px",
                backgroundColor: "white",
                borderRadius: "20px",
                width: "100%",
                height: "100%",
                textAlign: "start",
              }}
            >
              <PerfectScrollbar
                style={{ height: "100%" }}
                options={{ suppressScrollX: true }}
              >
                <p className="font-size2 pt-2">{t("Store categories")}</p>
                {show_brands?.data?.data?.brand.categories.map((Category, index) => (
                  <li
                    key={index}
                    style={{
                      marginTop: "10px",
                      color: "black",
                      width: "100%",
                      fontWeight: "400",
                      padding: "1%",
                      cursor: "pointer",
                    }}
                    onClick={() => gotoCategory(Category)}
                  >
                    {Category.name}
                  </li>
                ))}
              </PerfectScrollbar>
            </ul>
          </div>
        </div>
      </div>
      <span className="hr"></span>
      <div className="containe container">
        <div className="border_box2">
          <div className="background">
            <p className="Produ">
              {filters_data?.data?.data?.total_products} {t("Products")}
            </p>
            <div>
              {icons3.map((e, i) => (
                <div
                  key={i}
                  className={
                    e.length === 2
                      ? "show-on-small1"
                      : e.length === 3
                      ? "show-on-small2"
                      : e.length === 4
                      ? "show-on-small3"
                      : ""
                  }
                >
                  <p
                    className={`p ${openInde === i ? "selected" : ""}`}
                    onClick={() => handleRs(i)}
                  >
                    {e.map((item, index) => (
                      <span
                        key={index}
                        className={openInde === i ? "selected" : ""}
                      >
                        {item}
                      </span>
                    ))}
                  </p>
                  {openInde === i && (
                    <span
                      className="arrow"
                      style={{
                        marginInlineStart:
                          document.documentElement.dir === "rtl"
                            ? "-7px"
                            : openInde === 0 || openInde === 1 || openInde === 2
                            ? "-25px"
                            : "",
                      }}
                    >
                      &#9650;
                    </span>
                  )}
                </div>
              ))}
            </div>

            <div className="boxList" ref={menuRef}>
              <div className="level">
                <p>
                  {t("Sort by")}: <span>{text}</span>
                </p>
                <i
                  onClick={handelClick}
                  className={`${icon ? "activ" : "noActiv"}`}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </i>
              </div>

              {icon && (
                <div className="levels">
                  {sorts_data?.data?.data?.filter_titles.map((e, i) => (
                    <p key={i} onClick={() => (valueTeaxt(e), setIcon(!icon))}>
                      {e}
                    </p>
                  ))}
                </div>
              )}
            </div>
            <p className="close-btns" onClick={() => window.location.reload()}><FontAwesomeIcon icon={faTimes} /></p>
          </div>
        </div>
      </div>

      <div className="main-container container d-flex align-items-start">
        <div
          className={`main-cont ${
            isFilterVisible ? "col-0" : "col-12"
          } col-sm-4 ${isFilterVisible ? "slide-in" : "slide-out"}`}
          style={{
            display: openInde === 0 || openInde === 1 ? "none" : "block",
          }}
        >
          <button
            className="toggle-filter-btn"
            onClick={toggleFilterVisibility}
          >
            {isFilterVisible ? (
              <FontAwesomeIcon icon={faChevronRight} />
            ) : (
              <FontAwesomeIcon icon={faTimes} />
            )}
          </button>

          <div className="Filter_icon m-1">
            <p>{t("Filter")}</p>
            <i className="i" onClick={handleFilterDataClick}>
              <FontAwesomeIcon icon={faCheck} />
            </i>
          </div>

          {items?.map((item, index) => (
            <div key={index} className="main-item">
              <div
                className="item-headerr"
                onClick={() =>
                  setOpenIndex(openIndex === index + 1 ? null : index + 1)
                }
              >
                <p>{item.title}</p>
                <p className="arrow_icon">
                    <FontAwesomeIcon icon={faChevronRight} />
                </p>
              </div>
              {openIndex === index + 1 && (
                <div className="sub-items">
                  {item?.subItems?.map((subItem, subIndex) => (
                    <div
                      key={subIndex}
                      className="sub-item d-flex justify-content-between hover-bg"
                      onClick={() =>
                        handleAddFilter(item.key, {
                          title: subItem.filter_title,
                        })
                      }
                    >
                      <p>{subItem.filter_title}</p>
                      <div className="m d-flex ">
                        <p className="mx-2">{subItem.quantity}</p>
                        {selectedFilters[item.key]?.includes(
                          subItem.filter_title
                        ) && <span>✅</span>}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div
          className={`gallery1 container col-11 col-sm-${
            openInde === 0 ? 12 : openInde === 1 ? 12 : 7
          } `}
        >
          <div className="row">
            {loadingSearsh_brand && <Loader />}
            {loadingSort_products && <Loader />}
            {loadingFilter_brduct && <Loader />}
            {loadingShow_brand && <Loader />}

            {allProducts.map((product, index) => {
              // تحقق ما إذا كان المنتج موجود في قائمة الأمنيات
              const isInWishlist = favorite?.some(
                (item) => item.product_id === product.id
              );

              return (
                <>
                  {isFilterVisible && (
                    <div
                      className={`box mb-3 mx-auto  col-xxl-${
                        openInde === 0
                          ? 3
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 5
                          : 12
                      } px-xxl-${
                        openInde === 0
                          ? 5
                          : openInde === 1
                          ? 5
                          : openInde === 2
                          ? 5
                          : 0
                      } mx-xxl-${
                        openInde === 0
                          ? 0
                          : openInde === 1
                          ? 5
                          : openInde === 2
                          ? 3
                          : 0
                      }
        col-xl-${
          openInde === 0 ? 3 : openInde === 1 ? 3 : openInde === 2 ? 5 : 12
        } px-xl-${
                        openInde === 0
                          ? 4
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 3
                          : 0
                      } mx-xl-${
                        openInde === 0
                          ? 0
                          : openInde === 1
                          ? 2
                          : openInde === 2
                          ? 3
                          : 0
                      }
        col-lg-${
          openInde === 0 ? 3 : openInde === 1 ? 4 : openInde === 2 ? 5 : 12
        } px-lg-${
                        openInde === 0
                          ? 2
                          : openInde === 1
                          ? 5
                          : openInde === 2
                          ? 1
                          : 0
                      }
        col-md-${
          openInde === 0 ? 4 : openInde === 1 ? 4 : openInde === 2 ? 6 : 12
        } px-md-${
                        openInde === 0
                          ? 1
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 1
                          : 0
                      }
        col-sm-${
          openInde === 0 ? 4 : openInde === 1 ? 5 : openInde === 2 ? 11 : 12
        } px-sm-${
                        openInde === 0
                          ? 1
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 4
                          : 0
                      }
        col-${
          openInde === 0 ? 5 : openInde === 1 ? 5 : openInde === 2 ? 5 : 12
        } px-xs-${
                        openInde === 0
                          ? 1
                          : openInde === 1
                          ? 3
                          : openInde === 2
                          ? 0
                          : 0
                      }
        text-center g-0`}
                    >
                      <div className="border_box mb-5 ">
                        <div className="padding_box" onClick={() => gotoProductDetails(product)} >
                          <i
                          onClick={(event) => {
                            handelAdd_wishlist(product.id, event);
                            event.stopPropagation();
    
                          }}
                          >
                            <FontAwesomeIcon
                              icon={faHeart}
                              style={{ color: isInWishlist ? "red" : "white" }}
                            />
                          </i>
                          {product?.discount && (
                            <p className="discount">Off {product?.discount}</p>
                          )}
                          {product.main_image && (
                            <img
                              src={product.main_image}
                              alt={`img-${index}`}
                            />
                          )}
                          <p className="discraptoin">{product?.description}</p>
                          <div className="price align-items-center">
                            <p>{product?.new_price}</p>
                            {product?.old_price && (
                              <p className="old_price">{product?.old_price}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </div>
      </div>
      <Footer Sign_Up={Sign_Up} />
    </div>
  );
}

export default Brand;
